export function ReactionKingIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="24" r="12" />
      <path d="M18 24l-6-4" />
      <path d="M30 24l6-4" />
      <path d="M24 12v-4" />
      <circle cx="20" cy="22" r="1.5" fill="currentColor" />
      <circle cx="28" cy="22" r="1.5" fill="currentColor" />
      <path d="M20 28c2 2 6 2 8 0" />
    </svg>
  );
}
